@if (isInCheckout()) {
<div class="checkout-sub-promo-wrapper" *transloco="let t" role="status">
  <cwo-icon class="checkout-sub-promo-illustration" [name]="IconNameType.subscriptionSavings" [color]="'#FFE6C7'"
    size="123px" aria-hidden="true" />
  <div class="info-wrapper">
    <p class="checkout-sub-promo-text" [id]="promoTextId">
      @if (savingsPlan()) {
      {{isMultiplePlans()
        ? t('shared_components.checkout_sub_promo.you_save_up_to')
        : t('shared_components.checkout_sub_promo.you_saved')}}
      <span class="checkout-sub-promo-amount">{{savingsPlan() | currency: 'USD'}}</span>
      {{ t('shared_components.checkout_sub_promo.with_plan', {planName: planName()}) }}
      } @else {
      {{ t('shared_components.sub_cart_promo.subscription_savings_general') }}
      }
    </p>
    <button class="checkout-sub-promo-button" [attr.aria-describedby]="promoTextId" (click)="openPremiumPromo()">
      {{ t('shared_components.checkout_sub_promo.see_more') }}
    </button>
  </div>
</div>
}
@else {
<div class="subscription-savings-promo" *transloco="let t">
  @if (savingsPlan()){
  <span [id]="promoTextId">
    {{isMultiplePlans()
        ? t('shared_components.sub_cart_promo.subscription_savings_multi', {savings: savingsPlan(), planName: planName()})
        : t('shared_components.sub_cart_promo.subscription_savings_single', {savings: savingsPlan(), planName: planName()})}}
  </span>
  } @else {
  <span [id]="promoTextId">
    {{ t('shared_components.sub_cart_promo.subscription_savings_general') }}
  </span>
  }
  <br />
  <a class="subscription-savings-link" [href]="premiumRoute" [attr.aria-describedby]="promoTextId">
    {{isMultiplePlans()
      ? t('shared_components.sub_cart_promo.subscription_savings_check_plans')
      : t('shared_components.sub_cart_promo.subscription_savings_check_plan')}}
  </a>
</div>
}